export default "__VITE_ASSET__CZ2k8S_7__"